export const formatUserFullName = user => {
  if (!user) {
    return '';
  }
  return `${user.firstName ? user.firstName : ''} ${user.lastName ? user.lastName : ''}`;
};

/**
 * The display name of the access level an account holds.
 *
 * Takes the roles as the API reports them so the name is whatever an administrator
 * sees on the settings screen, and falls back to the stored key — a role that was
 * retired still has to render as something rather than as a blank cell.
 */
export const findRoleName = (roleKey, roles = []) => {
  if (!roleKey) return '';
  const match = roles.find(role => role.key === roleKey);
  return match ? match.name : roleKey;
};
